import InterviewerConfig from './InterviewerConfig';

export default InterviewerConfig;